import { withInstall } from '@ll-plus/utils'

import CollapsePanel from './src/collapse-panel.vue'
import Collapse from './src/collapse.vue'

export const LlCollapse = withInstall(Collapse)
export const LlCollapsePanel = withInstall(CollapsePanel)

export * from './src/collapse'

declare module 'vue' {
  export interface GlobalComponents {
    LlCollapse: typeof Collapse
    LlCollapsePanel: typeof CollapsePanel
  }
}
